import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../core/data/redux/store';
import { Toast } from 'primereact/toast';
import { Col } from 'antd';
import { getAllLeads, updateLead } from '../../services/leadServices';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TableNotFound from '../common/components/TableNotFound';
import { formatDate } from '../../utils/formatDate';
import LeadsModal from '../../feature-module/admin/common/modals/leads-modal';

const ListLeads = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useRef<Toast>(null);
  const data = useSelector((state: any) => state.lead);
  const {
    leads,
    isError,
    isLoading,
    errorMessage,
    leadCreated,
    leadUpdated,
  } = useSelector((state: any) => ({
    leads: state.lead.leads,
    isError: state.lead.isError,
    isLoading: state.lead.isLoading,
    errorMessage: state.lead.errorMessage,
    leadCreated: state.lead.leadCreated,
    leadUpdated: state.lead.leadUpdated,
  }));

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<any>(null);

  const handleEdit = (rowData: any) => {
    setSelectedLead(rowData);
    setIsEditModalOpen(true);
  };

  const handleDelete = (data: any) => {
    const softDeleteData = {
      ...data,
      is_deleted: true,
      is_active: false,
    }
    dispatch(updateLead(data.id, softDeleteData, setIsEditModalOpen));
  };

  const actionButton = (rowData: any) => {
    return (
      <div className="table-actions d-flex">
        <Link
          className="delete-table me-2"
          to="#"
          onClick={() => handleEdit(rowData)}
        >
          <Icon.Edit className="react-feather-custom" />
        </Link>
        <Link
          onClick={() => {
            handleDelete(rowData);
          }}
          className="delete-table border-none"
          to="#"
        >
          <Icon.Trash2 className="react-feather-custom" />
        </Link>
      </div>
    );
  };

  useEffect(() => {
    dispatch(getAllLeads());
    
    return () => {
      dispatch({ type: 'RESET_LEAD_ERRORS' });
    };
  }, [dispatch, leadCreated, leadUpdated]);

  return (
    <>
      <Toast ref={toast} />

      <div className="page-wrapper page-settings" style={{ paddingTop: '0px' }}>
        <div className="content">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              gap: 20,
              alignItems: 'center',
              paddingBottom: '2rem',
              flexWrap: 'wrap',
            }}
          >
            <Col
              style={{
                maxWidth: '700px',
              }}
            >
              <h5 style={{ margin: '0 0 2rem 0', padding: 0 }}>Leads</h5>
           
            </Col>

            <button
                className="btn btn-primary"
                type="button"
                onClick={() => setIsAddModalOpen(true)}
              >
              <i className="fa fa-plus me-2" />
              Add Lead
            </button>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="table-resposnive">
                <DataTable
                  paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  value={leads}
                  showGridlines
                  tableStyle={{ minWidth: '50rem' }}
                  loading={isLoading}
                  emptyMessage={
                    !isLoading && (
                      <TableNotFound
                        Icon={Icon.FileText}
                        title={
                          'No Leads Found'
                        }
                      />
                    )
                  }
                >
                  <Column
                    header="#"
                    body={(rowData, options) => options.rowIndex + 1}
                    style={{ width: '3rem' }}
                  ></Column>
                  <Column
                    sortable
                    field="first_name"
                    header="First Name"
                  ></Column>
                  <Column
                    sortable
                    field="last_name"
                    header="Last Name"
                  ></Column>
                  <Column sortable field="email_address" header="Email"></Column>
                  <Column sortable field="phone_number" header="Phone"></Column>
                  <Column sortable field="source_type" header="Source Type"></Column>
                  <Column sortable field="created_at" header="Created At"
                  body={(rowData) => {
                    return formatDate(rowData.created_at.split('T')[0]);
                  }}
                  ></Column>
                  <Column sortable field="is_active" header="Status"></Column>
                  <Column sortable field="is_deleted" header="Deleted"></Column>
                  
                  <Column
                    field="action"
                    header="Actions"
                    body={actionButton}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LeadsModal
        selectedLead={selectedLead}
        setIsAddModalOpen={setIsAddModalOpen}
        isAddModalOpen={isAddModalOpen}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
      />
    </>
  );
};

export default ListLeads; 